import Avatar from "@material-ui/core/Avatar"
import Button from "@material-ui/core/Button"
import Dialog from "@material-ui/core/Dialog"
import DialogContent from "@material-ui/core/DialogContent"
import DialogTitle from "@material-ui/core/DialogTitle"
import Divider from "@material-ui/core/Divider"
import IconButton from "@material-ui/core/IconButton"
import ListItem from "@material-ui/core/ListItem"
import ListItemAvatar from "@material-ui/core/ListItemAvatar"
import ListItemText from "@material-ui/core/ListItemText"
import { useTheme } from "@material-ui/core/styles"
import useMediaQuery from "@material-ui/core/useMediaQuery"
import ArrowForwardIosIcon from "@material-ui/icons/ArrowForwardIos"
import PersonPinCircleIcon from "@material-ui/icons/PersonPinCircle"
import StoreMallDirectoryRoundedIcon from "@material-ui/icons/StoreMallDirectoryRounded"
import { useSnackbar } from "notistack"
import { useContext, useEffect, useState } from "react"
import { useHistory } from "react-router-dom"
import SiteContext from "../../contexts/SiteContext"
import { TextosContext } from "../../contexts/TextosContext"

export default function DialogEnderecos(props) {
    const {
        loading,
        setLoading,

        usuarioLogado,
        setUsuarioLogado,

        aplicativoDados,
        setAplicativoDados,

        estabelecimentoAtual,
        setEstabelecimentoAtual,

        carrinho,
    } = useContext(SiteContext)
    const { textos } = useContext(TextosContext)

    const alertStart = (msg, tipo) => {
        enqueueSnackbar(msg, { variant: tipo })
    }

    const [enderecos, setEnderecos] = useState(
        usuarioLogado?.cliente?.enderecos ? usuarioLogado.cliente.enderecos : []
    )

    const {
        abrirEnderecos,
        setAbrirEnderecos,

        abrirCEP,
        setAbrirCEP,

        selecioneiRetiradaNoLocal,

        buscarCardapio,

        DialogConfirmacaoinformacoes,
    } = props

    useEffect(() => {
        setEnderecos(usuarioLogado?.cliente?.enderecos ?? [])

        if (abrirEnderecos && !estabelecimentoAtual?.manterEnderecoCliente) {
            setAbrirCEP(true)
            setAbrirEnderecos(false)
        }
    }, [abrirEnderecos])

    const history = useHistory()
    const theme = useTheme()
    const enqueueSnackbar = useSnackbar()
    const fullScreen = useMediaQuery(theme.breakpoints.down("sm"))

    const permiteRetiradaBalcao = () => {
        return aplicativoDados?.permiteRetiradaBalcao || estabelecimentoAtual?.permiteRetiradaBalcao
    }

    return (
        <Dialog
            open={abrirEnderecos}
            aria-labelledby="lista-enderecos-title"
            fullWidth={true}
            maxWidth={"md"}
            onClose={() => {
                setAbrirEnderecos(false)
            }}
            // style={{'zIndex': 10000}}
        >
            {!fullScreen ? <img src={aplicativoDados.urlLogo} className="imgModal" /> : null}

            <DialogTitle id="lista-enderecos-title">
                <IconButton
                    className="setaVoltarModal"
                    onClick={() => {
                        setAbrirEnderecos(false)
                    }}
                >
                    <ArrowForwardIosIcon />
                </IconButton>
                Endereços
            </DialogTitle>

            <DialogContent className="lista-enderecos">
                <Button
                    fullWidth
                    className="botao-adicionar-endereco"
                    onClick={() => {
                        setAbrirCEP(true)
                    }}
                >
                    {textos.adicionarEndereco}
                </Button>
                {permiteRetiradaBalcao() && (
                    <>
                        <Divider />
                        <ListItem
                            button
                            onClick={() => {
                                selecioneiRetiradaNoLocal()
                                setAbrirEnderecos(false)
                                if (carrinho.pedido?.formaPagamento?.id) {
                                    DialogConfirmacaoinformacoes(true)
                                }
                            }}
                            className="item-lista-enderecos"
                        >
                            <ListItemAvatar className="avatar-endereco-container">
                                <Avatar className="simbolo-endereco">
                                    <StoreMallDirectoryRoundedIcon />
                                </Avatar>
                            </ListItemAvatar>
                            <ListItemText
                                primary="Retirar no Local"
                                secondary="Busque seus produtos diretamente no estabelecimento"
                            />
                        </ListItem>
                    </>
                )}
                {enderecos.map((endereco, index) => {
                    if (!endereco.ativo) return
                    return (
                        <>
                            <Divider />
                            <ListItem
                                key={index}
                                button
                                onClick={() => {
                                    buscarCardapio(endereco)
                                    setAbrirEnderecos(false)
                                    if (carrinho.pedido?.formaPagamento?.id) {
                                        DialogConfirmacaoinformacoes(true)
                                    }
                                }}
                                className="item-lista-enderecos"
                            >
                                <ListItemAvatar className="avatar-endereco-container">
                                    <Avatar className="simbolo-endereco">
                                        <PersonPinCircleIcon />
                                    </Avatar>
                                </ListItemAvatar>
                                <ListItemText
                                    primary={`${endereco.logradouro}, Nº ${endereco.numero}${
                                        endereco.complemento ? ` - ${endereco.complemento}` : ""
                                    }`}
                                    secondary={`${endereco.bairro}, ${endereco.cidade} / ${endereco.uf}`}
                                />
                            </ListItem>
                        </>
                    )
                })}
            </DialogContent>
        </Dialog>
    )
}
